<div id="editAnswerModal" bg-close="false" uk-modal #modal>
  <div class="uk-modal-dialog">
    <button class="uk-modal-close-default" type="button" uk-close></button>

    <div class="uk-modal-header">
      <h3 i18n="@@Question">Question</h3>

      <p>{{ title }}</p>
    </div>

    <div class="uk-modal-body">
      <h3 i18n="@@Answer">Answer</h3>

      <div class="uk-flex">
        <div class="full-width">
          <textarea
            #answerText
            class="uk-textarea"
            placeholder="Answer"
            i18n-placeholder="@@Answer"
            rows="5"
            (input)="answerHandler($event)"
            >{{ answer }}</textarea
          >

          <div class="uk-flex uk-flex-between">
            <div>
              <span class="hint" i18n="@@htmlTags">You can use HTML tags.</span>
              <div class="form-error error-container">
                <small *ngIf="noAnswer" i18n="@@AnswerIsRequired"> Answer is required. </small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="uk-margin">
        <label>
          <span class="responder" i18n="@@Responder">Responder</span>

          <div *ngIf="!responderEdition" class="uk-flex uk-flex-between">
            <span>{{ responder }}</span>

            <fa-icon class="pointer" icon="edit" (click)="editResponder()"></fa-icon>
          </div>

          <div [style.visibility]="responderEdition ? 'visible' : 'hidden'" class="uk-flex uk-flex-middle uk-flex-between">
            <input class="uk-input" name="responder" type="text" />

            <fa-icon *ngIf="userId" class="pointer uk-margin-small-left" icon="times" (click)="responderEdition = false"> </fa-icon>
          </div>

          <div [style.margin-bottom]="responderEdition ? '24px' : '0'" class="form-error error-container">
            <small *ngIf="noUserChosen && (responderEdition || !userId)" i18n="@@needToPickExistingResponder">
              You need to pick existing responder.
            </small>
          </div>
        </label>
      </div>
    </div>

    <div class="uk-modal-footer">
      <p class="uk-text-right">
        <button class="uk-button uk-button-default uk-modal-close uk-margin-small-right" type="button" i18n="@@cancel">cancel</button>

        <button (click)="updateAnswer()" class="uk-button uk-button-primary confirm-button" type="button" i18n="@@save">save</button>
      </p>
    </div>
  </div>
</div>
